<template>
  <v-card class="bg-card">
    <v-progress-linear
      v-if="photosLoading"
      indeterminate
      height="2"
    ></v-progress-linear>
    <v-card-text>
      <v-layout row wrap>
        <v-flex sm1 v-if="!uploadMorePhotos">
          <div class="text-lg-left">
            <v-btn flat small @click="savePhotos()" color="primary"
              ><v-icon>arrow_back</v-icon>&nbsp;submit</v-btn
            >
          </div>
        </v-flex>
        <v-flex sm9 v-show="!uploadMorePhotos">
          <div v-if="photoLinks && photoLinks.length > 0">
            <span class="caption" style="padding-left: 40px;"
              >Drag photos to change order</span
            >
            <v-container grid-list-sm fluid>
              <grid-layout
                :layout.sync="photoLinks"
                :col-num="6"
                :row-height="250"
                :is-draggable="true"
                :is-resizable="false"
                :is-mirrored="false"
                :margin="[10, 10]"
                :use-css-transforms="true"
              >
                <grid-item
                  v-for="photoLink in photoLinks"
                  :x="photoLink.x"
                  :y="photoLink.y"
                  :w="photoLink.w"
                  :h="photoLink.h"
                  :i="photoLink.i"
                  :key="photoLink.i"
                  style="touch-action: none;"
                >
                  <v-card flat tile class="d-flex">
                    <div>
                      <v-img
                        :src="photoLink.url"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        height="130"
                      >
                        <template v-slot:placeholder>
                          <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                        <div class="pa-1" v-if="firstPhoto(photoLink)">
                          <v-avatar size="30" color="primary"
                            ><v-icon color="white">bookmark</v-icon></v-avatar
                          >
                        </div>
                        <div class="x-button">
                          <v-btn
                            round
                            color="error"
                            small
                            icon
                            @click="removePhoto(photoLink.i)"
                            ><v-icon>close</v-icon></v-btn
                          >
                        </div>
                      </v-img>
                      <v-textarea
                        solo
                        label="Comment"
                        v-model="photoLink.comment"
                        height="120"
                      ></v-textarea>
                    </div>
                  </v-card>
                </grid-item>
              </grid-layout>
            </v-container>
          </div>
          <div v-else>No photos added</div>
        </v-flex>
        <v-flex sm2 v-if="!uploadMorePhotos">
          <v-btn
            dense
            @click="uploadMorePhotos = true"
            dark
            color="pink"
            class="pr-2"
            >Add more photos</v-btn
          >
        </v-flex>
        <v-flex sm11 v-show="uploadMorePhotos">
          <v-layout row wrap>
            <v-flex sm1>
              <v-btn
                small
                flat
                @click="submitPhotosFromUpload()"
                :disabled="photos.length === 0"
                >add photos</v-btn
              >
              <v-btn small flat @click="cancelPhotosFromUpload()">cancel</v-btn>
            </v-flex>
            <v-flex sm11>
              <form class="dropzone" ref="dropzone">
                <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
                <div ref="dropzone-message" style="display: none">
                  <span class="dropzone-title">
                    {{ `Drop images here or click to select` }}
                  </span>
                </div>
              </form>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import VueGridLayout from "vue-grid-layout";
import Dropzone from "dropzone";
import "../../../node_modules/dropzone/dist/dropzone.css";
Dropzone.autoDiscover = false;
import { Auth, API } from "aws-amplify";
import { getPOGPhoto } from "@/api/map";

export default {
  name: "UploadPhotoPOG",

  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
  },

  props: {
    pog: {
      type: Object,
      default() {
        return {};
      },
    },
    acceptedFileTypes: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      photosLoading: false,
      uploadMorePhotos: false,
      photoLinks: [],
      photos: [],
    };
  },

  computed: {
    user() {
      return this.$store.state.settings.user;
    },
  },

  watch: {
    pog() {
      this.collectPhotos();
    },
  },

  methods: {
    initDropzone() {
      const self = this

      const options = {
        acceptedFiles: `${self.acceptedFileTypes}`,
        addRemoveLinks: true,

        // The URL will be changed for each new file
        url: "/",
        // `PUT` to upload to S3 directly
        method: "put",

        sending(file, xhr) {
          // Hijack the xhr.send since Dropzone always uploads files using formData
          // ref: https://github.com/danialfarid/ng-file-upload/issues/743
          let _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, file);
          };
        },
        // Upload one file at a time since we're using the S3 pre-signed URL scenario
        parallelUploads: 1,
        uploadMultiple: false,
        // Content-Type should be included, otherwise you'll get a signature
        // mismatch error from S3. We're going to update this for each file.
        header: "",
        // Customize the wording
        dictDefaultMessage: self.$refs["dropzone-message"].innerHTML,
        // We're going to process each file manually (see `accept` below)
        autoProcessQueue: false,

        accept(file, done) {
          // Request a signed upload URL when a file is accepted
          let uid = parseInt(Math.random() * 100000).toString();
          let name = `${uid}_${file.name
            .replace(/ /g, "_")
            .replace(/\//g, "_")}`;
          file.uniqueName = name;
          self.getSignedURL(file, name)
            .then((response) => {
              let url = response.body.tempLink;
              let date = new Date();

              self.photos.push({
                name: name,
                type: file.type,
                date: date
                  .toString()
                  .split(" ")
                  .slice(0, 5)
                  .join(" "),
              });
              file.uploadURL = url;
              done();
              // Manually process each file
              setTimeout(() => self.dropzone.processFile(file));
            })
            .catch((err) => {
              self.$emit("show-message", err, "red");
            });
        },
      };

      // Instantiate Dropzone
      this.dropzone = new Dropzone(this.$refs.dropzone, options);
      // Set signed upload URL for each file
      this.dropzone.on("processing", (file) => {
        self.dropzone.options.url = file.uploadURL;
      });
      this.dropzone.on("removedfile", (file) => {
        let photos = self.photos.filter((p) => {
          return p.name !== file.uniqueName;
        });
        self.photos = photos;
      });
    },
    savePhotos() {
      const photos = this.photoLinks.map((p) => {
        return {
          ...p.photo,
          comment: p.comment,
          x: p.x,
          y: p.y,
          i: p.i,
        };
      });

      this.$emit("add-photos", photos);
      this.$emit("done-photos");
    },
    async submitPhotosFromUpload() {
      for (let i = 0; i < this.photos.length; i++) {
        const photo = this.photos[i];

        let idx, x, y;
        if (this.photoLinks.length === 0) {
          idx = 0;
          x = 0;
          y = 0;
        } else {
          idx = Math.max(...this.photoLinks.map((pl) => pl.i)) + 1;
          x = Math.max(...this.photoLinks.map((pl) => pl.x)) + 1;
          y = Math.max(...this.photoLinks.map((pl) => pl.x));

          x = x > 5 ? 0 : x;
          y = x > 5 ? y + 1 : y;
        }

        const tempLink = await getPOGPhoto(null, null, photo);

        this.photoLinks.push({
          photo,
          x,
          y,
          i: idx,
          comment: null,
          url: tempLink,
          w: 1,
          h: 1,
        });
      }

      this.dropzone.removeAllFiles(true);
      this.photos = [];
      this.uploadMorePhotos = false;
    },
    cancelPhotosFromUpload() {
      this.uploadMorePhotos = false;
      this.dropzone.removeAllFiles(true);
      this.photos = [];
    },
    async getSignedURL(file, name) {
      const authData = await Auth.currentSession();
      let data = {
        body: {
          method: "put_object",
          contentType: file.type,
        },
        headers: {
          Authorization: authData.idToken.jwtToken,
        },
      };
      return API.post("api", `/${this.user.username}/data/${name}`, data);
    },
    async collectPhotos() {
      this.photoLinks = [];
      if (this.pog.photos) {
        let x = -1;
        let y = 0;

        for (let i = 0; i < this.pog.photos.length; i++) {
          const photo = this.pog.photos[i];

          if (x === 5) {
            x = 0;
            y++;
          }
          x++;

          const photoLink = { photo, w: 1, h: 1 };

          // Add new attributes to legacy objects
          photoLink.comment = photo.comment ? photo.comment : null;
          photoLink.x = photo.x === undefined ? x : photo.x;
          photoLink.y = photo.y === undefined ? y : photo.y;
          photoLink.i = photo.i === undefined ? i : photo.i;

          photoLink.url = await getPOGPhoto(this.pog, photoLink.i);

          this.photoLinks.push(photoLink);
        }
      }
    },

    firstPhoto(pl) {
      return (
        pl.x === Math.min(...this.photoLinks.map((pl) => pl.x)) &&
        pl.y === Math.min(...this.photoLinks.map((pl) => pl.y))
      );
    },

    removePhoto(idx) {
      this.photoLinks = [
        ...this.photoLinks.slice(0, idx),
        ...this.photoLinks.slice(idx + 1),
      ];
    },
  },

  beforeMount() {
    this.photosLoading = true;
    this.collectPhotos().finally(() => {
      this.photosLoading = false;
    });
  },

  mounted() {
    this.initDropzone();
  },
};
</script>

<style lang="stylus">
.x-button {
  position: absolute;
  right: 0px;
  top: 0px;
}

.bg-card {
  height: 400px;
  overflow-y: auto;
}

primaryBlue = #3498db;

form.dropzone {
  transition: all 0.2s linear;
  border: 2px dashed #ccc;
  background-color: #fafafa;
  min-height: 250px;

  &:hover {
    border-color: primaryBlue;
    background-color: white;

    .dz-message {
      .dropzone-title {
        color: primaryBlue;
      }
    }
  }

  .dz-message {
    color: #666;

    span {
      line-height: 1.8;
      font-size: 13px;
      letter-spacing: 0.4px;

      span.dropzone-title {
        display: block;
        color: #888;
        font-size: 1.25em;
      }

      span.dropzone-info {
        display: block;
        color: #a8a8a8;
      }
    }
  }
}
</style>
